<template>
  <div>
    <h3 class="modal__header">
      {{ modalHeaderText }}
    </h3>

    <validation-observer
      ref="observer"
      tag="div"
      class="saved-list-actions"
      @keyup.enter.native="saveList()">
      <validation-provider
        v-slot="{errors}"
        rules="required"
        slim>
        <oie-base-input
          v-model="name"
          :label-text="`${tStatic('shoppingListNameLabel')}*`"
          :error-messages="errors"
          :placeholder="tStatic('shoppingListPlaceholderLabel')"
          class="saved-list-actions__input">
        </oie-base-input>
      </validation-provider>

      <div class="saved-list-actions__actions-container">
        <oie-base-button css-classes="button--with-border button--blue" :text="modalSaveActionText" @click="saveList()"></oie-base-button>
        <oie-base-button css-classes="button--no-background" text="Avbryt" @click="closeThisModal()"></oie-base-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    name: null,
    errorMessages: null
  }),
  computed: {
    isNewList() {
      return this.currentList === undefined
    },
    currentList() {
      return this.options.currentList
    },
    modalHeaderText() {
      return this.isNewList ? this.tStatic('newShoppingList') : this.tStatic('updateShoppingList')
    },
    modalSaveActionText() {
      return this.isNewList ? this.tStatic('newShoppingListButtonCreate') : this.tStatic('genericSave')
    }
  },
  mounted() {
    if (!this.isNewList) {
      this.name = this.currentList.name
    }
  },
  methods: {
    saveList() {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          return
        }

        if (!this.isNewList) {
          this.options.currentList.name = this.name
          this.publish('shoppinglist.update', this.currentList)
        }

        if (this.isNewList) {
          this.publish('shoppinglist.create', { name: this.name, sourceList: this.options.listId })
        }

        this.resetOptions()
        this.closeThisModal()
      })
    },
    closeThisModal() {
      this.publish('modal.hide.create-edit-list')
    },
    resetOptions() {
      this.options.currentList = undefined
      this.options.listId = null
      this.name = null
    }
  }
}
</script>

<style lang="scss">
.saved-list-actions {
 display: flex;
 flex-direction: column;
 flex-wrap: wrap;
 align-items: flex-start;

 @include media(small) {
   flex-direction: row;
   align-items: flex-end;
 }
}

.saved-list-actions__input {
  margin-bottom: measure(half);
}

.saved-list-actions__actions-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include media(small) {
    flex-direction: row;
    align-items: center;
  }
}
</style>
